import { Vertragspartner, Signatur } from '@/models/VertragspartnerModels';

export type State = {
  vertragspartner: Array<Vertragspartner>;
  signaturen: Array<Signatur>;
};

export const state: State = {
  vertragspartner:
    localStorage.getItem('vertragspartner') != null && localStorage.getItem('vertragspartner') !== undefined
      ? JSON.parse(localStorage.vertragspartner)
      : new Array<Vertragspartner>(),
  signaturen:
    localStorage.getItem('signaturen') != null && localStorage.getItem('signaturen') !== undefined
      ? JSON.parse(localStorage.signaturen)
      : new Array<Signatur>(),
};
